import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useMemo } from 'react'

const CRUISE_MPV_RANKING_ROLLOUT = 'cruiseMarginPerViewRanking'

export default function useCruiseSearchMpvRankingFilters(filters: App.OfferListFilters): App.OfferListFilters {
  const { isAnyVariant: isCruiseMpvRankingEnabled } = useExperiment(Experiments.cruiseMpvRanking)

  return useMemo(() => {
    const rollout = isCruiseMpvRankingEnabled && !filters.rollout?.includes(CRUISE_MPV_RANKING_ROLLOUT) ?
        [...(filters.rollout ?? []), CRUISE_MPV_RANKING_ROLLOUT] :
      filters.rollout

    return {
      ...filters,
      offerSource: 'cruises',
      ...(rollout && { rollout }),
    }
  }, [filters, isCruiseMpvRankingEnabled])
}
